/** 去掉展示用前缀（如 `V.` / `v`），不参与版本逻辑 */
function firmwareVersionCore(version: string): string {
  return String(version || "")
    .trim()
    .replace(/^[Vv][.\s]*/, "")
    .trim();
}

/** 比较固件版本号，返回 v1 相对 v2：正数表示 v1 更新 */
export function compareFirmwareVersions(v1: string, v2: string): number {
  const parts1 = firmwareVersionCore(v1).split(".").map(Number);
  const parts2 = firmwareVersionCore(v2).split(".").map(Number);

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const p1 = parts1[i] || 0;
    const p2 = parts2[i] || 0;
    if (p1 !== p2) return p1 - p2;
  }
  return 0;
}
